module.exports = __webpack_public_path__ + "static/01-fba87acb31ebe7c289da0619ac7a420c.jpg";